import { render, staticRenderFns } from "./BoardFilter.vue?vue&type=template&id=670d0d12&scoped=true"
import script from "./BoardFilter.vue?vue&type=script&lang=js"
export * from "./BoardFilter.vue?vue&type=script&lang=js"
import style0 from "./BoardFilter.vue?vue&type=style&index=0&id=670d0d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d0d12",
  null
  
)

export default component.exports